import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import pt from './locales/pt.json';
import ru from './locales/ru.json';

// Язык задаётся URL-ом (/en/, /pt/, /ru/) — см. LangLayout и entry-client.
// Ресурсы встроены, поэтому инициализация синхронная (нужно для пререндера).
i18n.use(initReactI18next).init({
  resources: {
    ru: { translation: ru },
    en: { translation: en },
    pt: { translation: pt },
  },
  lng: 'en',
  fallbackLng: 'en',
  initAsync: false,
  interpolation: { escapeValue: false },
});

export default i18n;
